import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Billboard from '../billboard';


import './Billboards.css';


class Billboards extends React.Component {
    static propTypes = {
      billboards: PropTypes.object.isRequired,
      isLoading: PropTypes.bool.isRequired,
    }
    render() {
      const text = (this.props.isLoading || !this.props.billboards.messages.length) ? ['All', 'Or', 'Nothing'] : this.props.billboards.messages;
      return (<div className="billboards">
        <Billboard>{text[0]}</Billboard>
        <Billboard>{text[1]}</Billboard>
        <Billboard>{text[2]}</Billboard>
      </div>);
    }
}

const mapStateToProps = state => ({
  billboards: state.Billboards.data,
  isLoading: state.Billboards.isLoading,
});

const mapDispatchToProps = {

};

export default connect(mapStateToProps, mapDispatchToProps)(Billboards);



// WEBPACK FOOTER //
// ./src/components/billboards/Billboards.js